import { axios } from '@Root/API'

export const remove = (studyProgrammeId, supervisorAllocationId ) => {
	return axios.delete(`course-session/${studyProgrammeId}/supervisor-allocation/${supervisorAllocationId}`)
}
